import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { ButtonProps } from './button';
import { getButtonClassName } from './helper';
import { iconButton } from './iconButton.css';
import { CircularProgress } from '@mui/material';
import { PropsWithChildren } from 'react';

type ToggleButtonProps =
  | {
      toggle?: never;
      selected?: never;
      iconSelected?: never;
    }
  | {
      toggle: true;
      selected: boolean;
      iconSelected: FontAwesomeIconProps['icon'];
    };

type IconButtonProps = ButtonProps &
  Partial<Pick<FontAwesomeIconProps, 'icon'>> &
  ToggleButtonProps & {
    iconClassName?: string;
    className?: string;
    loading?: boolean;
  };

export const IconButton = ({
  iconClassName,
  ...p
}: PropsWithChildren<IconButtonProps>) => (
  <button
    type="button"
    {...p}
    className={
      p.variant === 'compact'
        ? clsx(
            iconButton({
              toggle: p.toggle,
              selected: p.selected,
              color: p.color,
              variant: 'compact',
            }),
            p.className,
          )
        : getButtonClassName({
            ...p,
            color:
              (p.variant ?? 'filled') === 'filled' && p.toggle && !p.selected
                ? 'primaryTonal'
                : p.color,
            className: clsx(
              p.className,
              iconButton({
                toggle: p.toggle,
                selected: p.selected,
                color: p.color,
                variant: 'default',
              }),
            ),
          })
    }
    data-testid={p?.['data-testid'] || p?.testId}
  >
    <>
      {p?.loading ? (
        <div>
          <CircularProgress
            size={p.variant === 'compact' ? 12 : 16}
            style={{
              color: 'inherit',
            }}
          />
        </div>
      ) : p.icon ? (
        <FontAwesomeIcon
          icon={p.selected ? p.iconSelected : p.icon}
          className={iconClassName}
        />
      ) : null}
      {p.children}
    </>
  </button>
);
